import { render, staticRenderFns } from "./WordSeparatorForm.vue?vue&type=template&id=87cd1d4a&scoped=true"
import script from "./WordSeparatorForm.vue?vue&type=script&lang=js"
export * from "./WordSeparatorForm.vue?vue&type=script&lang=js"
import style0 from "./WordSeparatorForm.vue?vue&type=style&index=0&id=87cd1d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cd1d4a",
  null
  
)

export default component.exports